// extracted by mini-css-extract-plugin
module.exports = {"signUpDropdown":"signupSection_signUpDropdown__ZRGi0"};